// 使用者資料
export default {
  USERS: 'users',
  GROUPS: 'groups',
  USEHISTORY: 'useHistory',
  ACTHISTORY: 'actHistory',
  QUESDATA: 'quesData',
  MENUTREE: 'menuTree'
}
